import React, { FC } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import classes from './menu-item.module.scss'
import { MenuItem as MenuItemType } from '../NavBar.types'

interface MenuItemProps {
  menuItem: MenuItemType
  className?: string
}

const MenuItem: FC<MenuItemProps> = ({
  menuItem: {
    id,
    label,
    as,
    isHidden,
    openOnNewPage,
    className: itemClassName,
    href,
    onClick,
    isNew,
    dataItemCategory,
    dataItemName,
  },
  className,
}) => {
  if (isHidden) return null

  const Tag = as || 'a'

  return (
    <Tag
      key={id}
      data-testid={id}
      className={cn(classes.item, className, itemClassName)}
      data-item-category={dataItemCategory}
      data-item-name={dataItemName}
      onClick={onClick}
      {...(Tag === 'a' && { href })}
      {...(Tag === Link && { to: href })}
      {...(openOnNewPage && {
        target: '_blank',
        rel: 'noreferrer',
      })}
    >
      {label}
      {isNew && <div className={classes.newItem}>New</div>}
    </Tag>
  )
}

export default MenuItem
